import { useState, useEffect } from 'react';
import { useDebouncedCallback } from '@eltoro-ui/hooks';

import { getPhotos, getPhotoSearch } from '@eltoro-ui/creative_generator/Requests';

import type { UnsplashPhotoType } from '@eltoro-ui/creative_generator/Typings';

export const useUnsplash = () => {
  const [search, setSearch] = useState('');
  const [photos, setPhotos] = useState<UnsplashPhotoType[]>([]);

  const handleDefaultPhotos = useDebouncedCallback(() => {
    getPhotos().then(res => {
      if (res.response) {
        const { results } = res.response;
        setPhotos(results);
      }
    });
  }, 200);

  const handleSearch = useDebouncedCallback((query: string) => {
    getPhotoSearch(query).then(res => {
      if (res.response) {
        const { results } = res.response;
        setPhotos(results);
      }
    });
  }, 200);

  useEffect(() => {
    if (search === '') {
      handleDefaultPhotos();
    } else {
      handleSearch(search);
    }
  }, [search]);

  return {
    photos,
    search,
    handleSearch: setSearch,
  };
};
